import { type StyleValue } from "vue";
import type { PopoverProps } from "../popover";
import type { TooltipSize } from "./constants";
import type { AlignedPlacement, Side } from "@floating-ui/utils";

export interface WLTooltipEmits {
  (event: "close"): void;
  (event: "update:isOpen", value: boolean): void;
}

export interface WLTooltipProps extends PopoverProps {
  size?: TooltipSize;
  placement?: Side | AlignedPlacement;
  content: {
    title?: string;
    description?: string;
    image?: string;
    hasClose?: boolean;
  };
  containerClasses?: StyleValue;
}
